export const isTableType = (type?: string): boolean => {
  if (!type) return false; // TODO: Add validation
  return ["Schedule", "List", "Periodic"].includes(type);
};
